import { IBotDictionaryApi } from '@/types';

export class BotDictionaryItem {
    id: number;
    name: string;

    constructor(data: IBotDictionaryApi) {
        this.id = data.id;
        this.name = data.name;
    }
}
